export default __webpack_public_path__ + "static/media/4700-Transmitter-No-background.5c012da3.png";